import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { applyHueShift } from "../engine/effects.js";

/**
 * HueShiftNode
 * ------------
 * Shifts hue, saturation, and brightness of the input canvas using CSS filters.
 */
export class HueShiftNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Hue Shift";

    this.properties = {
      shift: 0,
      saturation: 1,
      brightness: 1,
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    addDrivableSlider(this, "Hue", "shift", 0, 0, 360, 1);
    addDrivableSlider(this, "Saturation", "saturation", 1, 0, 3, 0.01);
    addDrivableSlider(this, "Brightness", "brightness", 1, 0, 3, 0.01);

    finalizeDrivableSliders(this, 1);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 100];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    const { shift, saturation, brightness } = this.properties;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyHueShift(ctx, w, h, { shift, saturation, brightness });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/HueShift", HueShiftNode);
